module.exports = __webpack_public_path__ + "static/media/plan.55bfc3c9.png";